import { useCart } from "../shared/CartContext";
import { Link } from "react-router-dom";

export default function CartDrawer({ open, onClose }) {
  const { items, removeItem, setQuantity, totals, clear } = useCart();
  const list = Array.from(items.entries());

  return (
    <div
      className={`fixed inset-0 z-40 ${open ? "" : "pointer-events-none"}`}
      aria-hidden={!open}
    >
      {/* Background Overlay */}
      <div
        className={`absolute inset-0 bg-black/40 transition-opacity ${
          open ? "opacity-100" : "opacity-0"
        }`}
        onClick={onClose}
      />

      {/* Drawer Panel */}
      <aside
        className={`absolute right-0 top-0 h-full w-full sm:w-[420px] bg-white shadow-2xl transform transition-transform duration-500 ease-in-out ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Header */}
        <div className="p-6 border-b flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">Your Cart</h3>
          <button
            className="text-gray-500 hover:text-gray-700 transition"
            onClick={onClose}
          >
            Close
          </button>
        </div>

        {/* Cart Items */}
        <div className="p-6 space-y-4 max-h-[calc(100%-200px)] overflow-auto">
          {list.length === 0 ? (
            <div className="text-gray-600 text-center mt-10">
              Your cart is empty.
            </div>
          ) : (
            list.map(([key, item]) => (
              <div
                key={key}
                className="flex items-start gap-3 border rounded-lg p-3 hover:shadow-md transition-all"
              >
                <div className="flex-1">
                  <div className="font-medium text-gray-900">{item.title}</div>
                  <div className="text-sm text-gray-600">{item.subtitle}</div>
                  <div className="mt-1 text-blue-600 font-semibold">
                    Rs {item.price.toFixed(2)}
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <input
                    type="number"
                    min={1}
                    value={item.quantity}
                    onChange={(e) => setQuantity(key, Number(e.target.value))}
                    className="w-16 border rounded px-2 py-1 focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                  <button
                    className="text-red-600 text-sm hover:underline"
                    onClick={() => removeItem(key)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Summary */}
        {list.length > 0 && (
          <div className="p-6 border-t mt-auto bg-gray-50">
            <div className="flex justify-between text-sm text-gray-700">
              <span>Subtotal</span>
              <span>Rs {totals.subtotal.toFixed(2)}</span>
            </div>

            {/* Total = Subtotal (no tax) */}
            <div className="flex justify-between font-semibold text-gray-900 mt-2">
              <span>Total</span>
              <span>Rs {totals.subtotal.toFixed(2)}</span>
            </div>

            <div className="mt-4 flex gap-2">
              <Link
                to="/checkout"
                onClick={onClose}
                className="flex-1 text-center bg-gradient-to-r from-blue-600 to-cyan-500 text-white py-3 rounded-lg font-semibold hover:opacity-90 transition-all"
              >
                Checkout
              </Link>
              <button
                className="px-4 py-3 border rounded-lg text-gray-700 hover:bg-gray-100 transition"
                onClick={clear}
              >
                Clear
              </button>
            </div>
          </div>
        )}
      </aside>
    </div>
  );
}
